import React from 'react';
import { EMBED_ERROR, toDrivePreviewUrl } from '../utils/drive';
interface AudioMasterProps {
  label: string;
  driveUrl: string;
}

/**
 * The audio review player.
 *
 * A Google Drive audio link is embedded directly — Drive's own preview UI
 * supplies playback, scrubbing and volume, so nothing here needs to fake
 * transport controls or track a runtime that was never real. No link, or a
 * link Drive can't embed, is stated plainly rather than shown as a working
 * player.
 */
export function AudioMaster({
  label,
  driveUrl
}: AudioMasterProps) {
  const embedUrl = toDrivePreviewUrl(driveUrl);
  const linkProvided = Boolean(driveUrl.trim());
  /** Only the link itself can be judged — Drive is cross-origin and opaque. */
  const showError = linkProvided && !embedUrl;
  return <div className="border-t border-rule py-6" data-id="element-21" data-mp="174eqqi7o6myn">
      <p className="font-display text-lg leading-none" data-id="element-22" data-mp="17699bpvgy2zk">{label}</p>

      {embedUrl ? <div className="relative mt-5 h-20 w-full overflow-hidden border border-rule bg-paperDeep" data-id="element-23" data-mp="12d6g5iulsvjw">
          <iframe title={label} src={embedUrl} allow="autoplay" className="h-full w-full border-0" data-id="element-24" data-mp="27ebst7tjpd12" />
        </div> : showError ? <div className="mt-5 border border-rule bg-paperDeep px-5 py-4" data-id="element-25" data-mp="1xmeis4e9wr3x">
          <p className="label-sm m-0 text-mute" data-id="element-26" data-mp="22lr5mp559y6i">{EMBED_ERROR}</p>
          <a href={driveUrl} target="_blank" rel="noreferrer" className="label mt-3 inline-block text-graphite underline underline-offset-4 transition-colors duration-150 ease-out hover:text-ink" data-id="element-27" data-mp="22jxw9235czut">
            Open in Google Drive
          </a>
        </div> : <p className="label-sm mt-5 text-mute" data-id="element-28" data-mp="1jmwoxam4ennp">Awaiting Drive link</p>}
    </div>;
}